import React, { useState } from "react";
import { FaUpload, FaEnvelope, FaUser, FaPhone, FaGraduationCap, FaCalendar, FaFile, FaPencilAlt } from "react-icons/fa";
import { submitRecruitment } from "../../../services/recruitment_submission";
import { ClipLoader } from 'react-spinners';
import recruitmentBg from "../../../images/recruitment/recruitment.jpg";

function Recruitment() {
    const [cvLabel, setCvLabel] = useState("CV (PDF)");
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        cv: null,
        course: "",
        year: "",
        motivation: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, cv: file });
        setCvLabel(file ? file.name : "CV (PDF)");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await submitRecruitment(formData);
            setFormData({ name: "", email: "", phone: "", cv: null, course: "", year: "", motivation: "" });
            setCvLabel("CV (PDF)");
        } catch (error) {
            console.error("Submission failed:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div 
            className="relative flex flex-col items-center justify-center w-full min-h-screen py-32 overflow-hidden"
            style={{
                backgroundImage: `linear-gradient(to bottom, rgba(15, 23, 42, 0.3), rgba(15, 23, 42, 0.8)), url(${recruitmentBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div className="w-full max-w-xl px-6 z-20">
                <h1 className="font-custom md:text-7xl text-3xl text-center font-bold text-white mb-6">RECRUITMENT</h1>
                <p className="text-gray-200 font-medium font-custom text-center mb-5 text-sm">
                        At the moment, we are not in a recruitment phase. 
                        However, if you wish to join the team, feel free to submit a spontaneous application.
                    </p>
                <div className="bg-gray-100/95 backdrop-blur-sm rounded-2xl shadow-2xl p-5 md:p-6 border border-gray-200">
                    <form className="space-y-3" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="relative">
                                <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <input
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                    type="text"
                                    placeholder="Name"
                                    required
                                />
                            </div>

                            <div className="relative">
                                <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <input
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                    type="email"
                                    placeholder="Email"
                                    required
                                />
                            </div>

                            <div className="relative">
                                <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <input
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                    type="tel"
                                    placeholder="Phone Number"
                                    required
                                />
                            </div>

                            <div className="relative">
                                <FaGraduationCap className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <input
                                    name="course"
                                    value={formData.course}
                                    onChange={handleChange}
                                    className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                    type="text"
                                    list="courses"
                                    placeholder="Course"
                                    required
                                />
                                <datalist id="courses">
                                    <option>Computer Engineering</option>
                                    <option>Mechanical Engineering</option>
                                    <option>Electrical Engineering</option>
                                    <option>Industrial Engineering and Management</option>
                                    <option>Bioengineering</option>
                                    <option>Civil Engineering</option>
                                    <option>Materials Engineering</option>
                                    <option>Physics Engineering</option>
                                    <option>Mining and Geo-Environmental Engineering</option>
                                    <option>Chemical Engineering</option>
                                    <option>Environmental Engineering</option>
                                </datalist>
                            </div>

                            <div className="relative">
                                <FaCalendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <input
                                    name="year"
                                    value={formData.year}
                                    onChange={handleChange}
                                    className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                    type="number"
                                    placeholder="Course Year"
                                    min="1" 
                                    max="5"
                                    required
                                />
                            </div>

                            <div className="relative">
                                <FaFile className="absolute left-3 top-1/2 transform -translate-y-1/2 text-mainBlue text-sm"/>
                                <label htmlFor="cv" className="block w-full text-left text-gray-400 bg-white rounded-lg p-2.5 pl-10 border border-gray-200 cursor-pointer hover:border-mainBlue transition-colors text-sm">
                                    {cvLabel}
                                    <FaUpload className="absolute right-3 top-1/2 transform -translate-y-1/2 text-mainBlue"/>
                                </label>
                                <input
                                    id="cv"
                                    name="cv"
                                    onChange={handleFileChange}
                                    className="hidden"
                                    type="file"
                                    accept="application/pdf"
                                    required
                                />
                            </div>
                        </div>

                        <div className="relative">
                            <FaPencilAlt className="absolute left-3 top-5 transform -translate-y-1/2 text-mainBlue text-sm"/>
                            <textarea
                                name="motivation"
                                value={formData.motivation}
                                onChange={handleChange}
                                className="w-full text-left text-slate-700 rounded-lg p-2.5 pl-10 pt-2 outline-none border border-gray-200 focus:border-mainBlue transition-colors placeholder-gray-400 text-sm"
                                rows="3"
                                placeholder="Motivation"
                                required
                            ></textarea>
                        </div>

                        <div className="w-full flex justify-center mt-4">
                            <button 
                                className="text-base font-bold bg-white text-slate-900 rounded-full px-6 py-2 hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom"
                                type="submit" 
                                disabled={loading}
                            >
                                {loading ? (
                                    <ClipLoader size={18} color={"#1e293b"} loading={loading} />
                                ) : (
                                    "SUBMIT APPLICATION"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Recruitment;
